var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "8px",
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "14482F61-68D3-4D23-9B07-4634276B0C01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Master",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile",
    transform: "translate(-244.000000, -33.000000)",
    fill: "#191919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "arrow",
    points: "250.504778 38.3982773 255.903055 33 257.16129 34.2582352 250.497304 40.9222216 249.239069 39.6639864 249.246543 39.6565126 244 34.40997 245.258235 33.1517348 250.504778 38.3982773"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_arrow.12b7cf82bf2cd50bee8b879ec7e82423.svg";